// src/admin/companies/OrphanCompanies.jsx — «L'azienda X resta senza tenant.» + «Apri l'azienda», one line per
// company a tenant / person purge leaves with no tenant (BE `companies_without_workspace[]`, v212). Needs a Router.
// ⛔ Only the company's legal name (user data) and our sentence — never server text.
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { companyPath, orphanLineKeys } from './companyModel.js';
import { COLORS, FONT_SANS } from '../../constants/theme.js';

export default function OrphanCompanies({ companies }) {
  const { t } = useTranslation('admin');
  const list = Array.isArray(companies) ? companies : [];
  if (list.length === 0) return null;
  const lines = orphanLineKeys(list);
  return (
    <ul style={{ margin: '0 0 8px', paddingLeft: '18px', fontSize: '13px', lineHeight: 1.5, color: COLORS.ink, fontFamily: FONT_SANS }}>
      {list.map((c, i) => (
        <li key={c.customer_id}>
          {t(lines[i].key, lines[i].params)}{' '}
          <Link to={companyPath(c.customer_id)} style={{ color: COLORS.accent }}>{t('purge.orphan.open')}</Link>
        </li>
      ))}
    </ul>
  );
}
